import React from "react";
import { size } from "lodash";
import styled from "styled-components";
import { PeriodRange } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import Chip from "@ui-kit/form/chip";
import Loading from "@ui-kit/loading";
import Recap from "@radarly/components/clause/labels/labels";
import Tooltip from "@radarly/components/clause/labels/tooltip";
import { useLabelsFromClause } from "@radarly/core/clause/use-cases";
import { useFacetsFromContext } from "@radarly/core/facets/use-cases";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { Clause } from "@radarly/models/clause";
import { isClauseFieldFilled } from "@radarly/models/clause/is";
import { getFacetFromField } from "@radarly/models/facets";

interface IProps {
  field: string;
  clause: Clause;
  period: PeriodRange;
  locale: Locale;
}

const LoaderContainer = styled.div`
  position: relative;
  width: 72px;
  padding: 3px 0 0 8px;
`;

const Loader = () => (
  <LoaderContainer>
    <Loading size="s" />
  </LoaderContainer>
);

const Root = styled.div`
  display: flex;
  align-items: center;
`;

const PastedFilterChip = ({ clause, field, period, locale }: IProps) => {
  const facets = useFacetsFromContext();
  const facet = getFacetFromField(facets, field);
  const project = useCurrentProject();
  const { loading, labels } = useLabelsFromClause(
    project.id,
    clause,
    facets,
    locale,
    period
  );
  return (
    <Root>
      <Tooltip
        disabled={!labels.length}
        locale={locale}
        title={facet?.label}
        clausesLabels={labels}
      >
        <Chip
          label={
            loading ? (
              <Loader />
            ) : size(labels) ? (
              <Recap clauseLabels={labels[0]} locale={locale} />
            ) : (
              facet?.label
            )
          }
          status={isClauseFieldFilled(clause, facet?.id) ? "selected" : "none"}
          size="large"
        />
      </Tooltip>
    </Root>
  );
};

export default PastedFilterChip;
